import React, { useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch } from "react-redux";

//component
import LayoutHeader from "../00_Nav/layout/layout_header";
import TriggerInit from "./trigger/trigger_init";
import TaskEmpty from "./component/task_empty";
import TaskDetail from "./component/task_detail";
//action
import { setHighlight } from "../../store/bailiff/nav/nav.action";
import TriggerUrl from "./trigger/trigger_url";
import DetailTracking from "./component/detail_tracking";

import "./style.css";
import DialogViewScore from "./dialog/dialog_view_score";
import TriggerPage from "./trigger/trigger_page";
import NotificationCard from "./component/notification_card";

const { Content } = Layout;

const TaskScreen = () => {
  // -------------------------- VAR --------------------------
  const title = "Nơi làm việc";

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row justify={"center"} gutter={[0, 30]}>
          <Col
            align="center"
            style={{ marginTop: 20 }}
            xl={12}
            lg={12}
            md={22}
            xs={24}
          >
            <NotificationCard />
            <DetailTracking />
            <TaskEmpty />
            <TaskDetail />
          </Col>
        </Row>
        <DialogViewScore />
        <TriggerInit />
        <TriggerPage />
        <TriggerUrl />
      </Content>
    </Layout>
  );
};

export default TaskScreen;
